import { createTheme as createMuiTheme, responsiveFontSizes } from '@mui/material/styles';

import createBaseOptions from './base/create-options';

/**
 * @typedef {import('@mui/material/styles').Theme & import('./base/create-options').BaseVanSiteTheme } VanSiteTheme
 */

// Heading sizes (px) for 900-1199 px only (tablets and small laptops). `responsiveFontSizes` would
// otherwise scale them to almost the desktop size there (h1 51 px, h2 43 px).
export const MD_HEADING_FONT_SIZES = { h1: 40, h2: 34, h3: 30, h4: 26, h5: 22 };

/**
 * Overrides the heading sizes from `md` up. The `lg` media query that `responsiveFontSizes` emitted
 * is later in the cascade, so from 1200 px the computed sizes stay exactly as before.
 * @param {VanSiteTheme} theme - Theme after `responsiveFontSizes`
 * @returns {VanSiteTheme}
 */
const applyMdHeadingSizes = (theme) => {
  const mdQuery = theme.breakpoints.up('md');
  Object.entries(MD_HEADING_FONT_SIZES).forEach(([variant, size]) => {
    theme.typography[variant][mdQuery] = { fontSize: `${size / 16}rem` };
  });
  return theme;
};

/**
 * @param {'mobile' | 'desktop'} deviceType
 * @returns {VanSiteTheme} - The theme object
 */
export const createTheme = (deviceType) => {
  // Create the basic theme object
  let theme = createMuiTheme(
    // Base options available for both dark and light palette modes
    createBaseOptions({ deviceType })
  );

  // Apply responsive fonts
  theme = responsiveFontSizes(theme);

  return applyMdHeadingSizes(theme);
};
